module.exports = __webpack_public_path__ + "img/42.4a7f7107.jpeg";